import { CdkDragDrop, DragDropModule } from '@angular/cdk/drag-drop';
import { Location } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { SectionEditComponent } from '../../../components/tile/edit/section/section.component';
import { BuilderStatusService } from '../../../services/builder/builder-status.service';
import { BuilderService } from '../../../services/builder/builder.service';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { HistoryService } from '../history.service';
import { openMediumDialog } from '@sportello-balneari/shared-components';
import { DialogService } from 'primeng/dynamicdialog';
import { InstructionComponent } from './instructions.component';

@Component({
  selector: 'lib-module-builder',
  templateUrl: './module-builder.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatButtonModule,
    DragDropModule,
    MatIconModule,
    TooltipModule,
    ConfirmDialogModule,
    SectionEditComponent,
  ],
  providers: [Location, ConfirmationService],
})
export class ModuleBuilderComponent {
  protected readonly builderService = inject(BuilderService);
  protected readonly historyService = inject(HistoryService);
  protected readonly dragDropService = inject(DragDropService);
  protected readonly builderStatusService = inject(BuilderStatusService);
  protected readonly dialog = inject(DialogService);

  drop(event: CdkDragDrop<string[], string, string>) {
    if (
      event.previousIndex === event.currentIndex &&
      event.previousContainer.id === event.container.id
    )
      return;

    this.builderService.moveSection(event.previousIndex, event.currentIndex);
  }

  openInstructions() {
    openMediumDialog(this.dialog, InstructionComponent, {
      header: "Istruzioni per l'utilizzo della logica",
      closable: false,
    });
  }
}
